type InternalReplaceLocation = {
  pathname: string;
  search: string;
};

type InternalReplaceLocationParams = {
  pathname: string;
  currentSearch: string;
  nextSearch: string | URLSearchParams;
};

const normalizeSearch = (search: string | URLSearchParams) => {
  const searchString = search instanceof URLSearchParams ? search.toString() : search;

  return searchString.startsWith('?') ? searchString.slice(1) : searchString;
};

export const removeUsedQueryKeys = (
  searchParams: URLSearchParams,
  usedQueryKeys: readonly string[],
) => {
  const nextSearchParams = new URLSearchParams();

  searchParams.forEach((value, key) => {
    if (!usedQueryKeys.includes(key)) {
      nextSearchParams.set(key, value);
    }
  });

  return nextSearchParams.toString();
};

export const createInternalReplaceLocation = ({
  pathname,
  currentSearch,
  nextSearch,
}: InternalReplaceLocationParams): InternalReplaceLocation | null => {
  const normalizedCurrentSearch = normalizeSearch(currentSearch);
  const normalizedNextSearch = normalizeSearch(nextSearch);

  if (normalizedCurrentSearch === normalizedNextSearch) {
    return null;
  }

  return {
    pathname,
    search: normalizedNextSearch,
  };
};
